import { ProfileState } from "@/components/ProfileSideDrawer/redux/types";

const profileInitialState: ProfileState = {
  isProfileOpen: false,
  isOpenOnboardingSteps: false,
  onboardingJourneySteps: null,
  loading: false,
  error: null,
};

export default profileInitialState;
